<script setup lang="ts">
import { toRefs } from "vue";
import type { Product } from "@shopware-pwa/types";
import { Tint } from "~/components/clarity-ui/Tint";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import SvgIcon from "~/templates/elements/SvgIcon.vue";

export interface ProductAvailabilityProps {
  product: Product;
  isAvailable: boolean;
}

const props = defineProps<ProductAvailabilityProps>();
const { product } = toRefs(props);
</script>

<template>
  <div v-if="isAvailable" class="flex items-start gap-x-3">
    <Tint color="success"
      ><SvgIcon aria-hidden="true" class="h-5 w-5" name="Checkmark-Circle"
    /></Tint>
    <Tint color="success"
      ><CommonLabel
        :placeholder="{ deliveryTime: product?.deliveryTime?.name }"
        path="BWF/shop/productDetailPage/deliveryTime"
    /></Tint>
  </div>
  <template v-else>
    <Tint><CommonLabel path="BWF/shop/productDetailPage/productNotAvailable" /></Tint>
  </template>
</template>
